export default "__VITE_ASSET__BhHmLuo1__"